/**
 * 동기화 큐 훅 (호환성 레이어)
 *
 * 기존 import 경로(@/hooks/useSyncQueue)를 유지하면서
 * SyncQueueContext로 위임하는 래퍼입니다.
 */

import { useSyncQueueContext } from "@/contexts/SyncQueueContext";

export function useSyncQueue() {
  return useSyncQueueContext();
}
